import { IProductAttributeResponse } from "api/interfaces/analytics.type";
import axios from "fetch-api/fetch-api";

export function getProductAttributesApi(skus: string[]) {
  return axios.get<IProductAttributeResponse>(`s/analytics/product-attributes?skus=${skus}`);
}
